import { z } from 'zod'

/**
 * Schéma pour les préférences d'onboarding de l'utilisateur
 */
export const UserOnboardingPreferencesSchema = z.object({
  isGeneralCompleted: z.boolean().default(false),
  isDiagnosticCompleted: z.boolean().default(false),
  isModuleCompleted: z.boolean().default(false),
})

export type UserOnboardingPreferencesEntity = z.infer<typeof UserOnboardingPreferencesSchema>

/**
 * Schéma pour les préférences utilisateur
 */
export const UserPreferencesSchema = z.object({
  onboarding: UserOnboardingPreferencesSchema.optional(),
  extras: z.record(z.string(), z.unknown()).optional(),
})

export type UserPreferencesEntity = z.infer<typeof UserPreferencesSchema>
